import { Fab, makeStyles } from "@material-ui/core";
import { stringify } from "querystring";
import * as React from "react";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme: any) => ({
  container: {
    display: "block" as "block",
    textAlign: "center" as "center"
  },
  page: {
    display: "inline-block" as "inline-block",
    margin: "0 4px"
  },
  pageBtn: {
    background: "none" as "none",
    boxShadow: "none" as "none"
  },
  pageList: {
    display: "inline-block" as "inline-block",
    listStyle: "none" as "none"
  },
  selected: {
    backgroundColor: theme.palette.primary.main,
    color: "#ffffff"
  }
}));

interface IProps {
  path: string;
  params?: Record<string, string>;
  pageCount: number;
  currentPage: number;
}

const Paginator = ({ pageCount, currentPage, params = {}, path }: IProps) => {
  const classes = useStyles();
  const pagesList = React.useMemo(() => {
    return new Array(pageCount).fill(null);
  }, [pageCount]);

  const getPageUrl = React.useCallback(
    (newPage: number) => {
      return `${path}?${stringify({
        ...params,
        page: newPage
      })}`;
    },
    [params, path]
  );

  const getBtnClasses = React.useCallback(
    (checkPage: number) => {
      return checkPage === currentPage ? [classes.pageBtn, classes.selected].join(" ") : classes.pageBtn;
    },
    [currentPage]
  );

  return pageCount > 1 ? (
    <div className={classes.container}>
      <ul className={classes.pageList}>
        {pagesList.map((_, pageNum) => {
          pageNum += 1;

          return (
            <li className={classes.page} key={pageNum}>
              <Link to={getPageUrl(pageNum)}>
                <Fab className={getBtnClasses(pageNum)} size="small">
                  {pageNum}
                </Fab>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
};

export default React.memo(Paginator);
